import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './stylings/global.styles.scss';
import '@sanlam-glacier/app-common/cx/override';

const element = document.getElementById('app');

const root = createRoot(element as Element);

root.render(
  <StrictMode>
    <App />
  </StrictMode>
);
